<template>
    <div>
        <div class="text-right">
            <a class="btn btn-primary" href="/webchat/create">
                <i class="fa fa-plus mr-1"></i> New Webchat
            </a>
        </div>
        <card-spinner v-if="loading" style="height: 200px;"/>
        <webchat-list-item
            v-else
			v-for="webChat in webChats.data"
			:key="webChat.id"
			:webchat="webChat"
			@deleted="fetchWebChats"
			@replicated="fetchWebChats"
		/>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    data() {
        return {
            loading: true,
            webChats: {
                data: [],
                links: null,
                meta: null,
            }
        }
    },

    computed: {
        ...mapState({
            filter: state => state.filter,
        }),
    },

    watch: {
        filter() {
            this.fetchWebChats();
        },
    },

    created() {
        this.fetchWebChats();
    },

    methods: {
        async fetchWebChats() {
            this.loading = true;
            await this.$http.get(this.$laroute.route('webchat.list'), {
                params: {
                    filter: {...this.filter},
					hide: 'campaigns'}
            	})
                .then( ({data: webChats}) => this.webChats = webChats);

            this.loading  = false;
        },
    }
}
</script>
